/**
 * Payment utilities for Telegram Stars integration
 */

import { api } from '@/api';
import { TelegramUtils } from './telegram';
import type { InvoiceType } from '@/types';

export class PaymentHelper {
  /**
   * Purchase with Telegram Stars
   */
  static async purchaseWithStars(invoiceType: InvoiceType): Promise<boolean> {
    try {
      // 1. Create invoice
      console.log('💳 Creating invoice for:', invoiceType);
      const invoice = await (api as any).createPaymentInvoice({ 
        invoice_type: invoiceType 
      });
      
      console.log('✅ Invoice created:', invoice);
      
      // 2. Open Telegram payment UI
      console.log('💰 Opening payment UI...');
      const status = await TelegramUtils.openInvoice(invoice.invoice_link);
      
      console.log('📊 Payment status:', status);
      
      if (status === 'paid') {
        // 3. Wait for backend confirmation
        console.log('⏳ Waiting for backend confirmation...');
        const confirmed = await this.waitForConfirmation(invoice.invoice_id);
        
        if (confirmed) {
          console.log('✅ Payment confirmed by backend');
          return true;
        } else {
          console.warn('⚠️ Payment not confirmed by backend, but callback says paid');
          // Показать сообщение что оплата обрабатывается
          await TelegramUtils.showAlert('Оплата обрабатывается. Доступ будет активирован в течение минуты.');
          return false;
        }
      }
      
      if (status === 'cancelled') {
        console.log('❌ Payment cancelled by user');
        await TelegramUtils.showAlert('Оплата отменена');
      } else if (status === 'failed') {
        console.log('❌ Payment failed');
        await TelegramUtils.showAlert('Ошибка оплаты. Попробуйте еще раз.');
      }
      
      return false;
    } catch (error) {
      console.error('💥 Payment error:', error);
      await TelegramUtils.showAlert('Не удалось создать платеж. Попробуйте позже.');
      return false;
    }
  }

  /**
   * Wait for backend confirmation via polling
   */
  static async waitForConfirmation(
    invoiceId: number,
    maxAttempts: number = 10
  ): Promise<boolean> {
    for (let i = 0; i < maxAttempts; i++) {
      await this.sleep(1000);
      
      try {
        const statusResponse = await (api as any).checkInvoiceStatus(invoiceId);
        
        if (statusResponse.status === 'paid') {
          return true;
        }
      } catch (error) {
        console.error(`Attempt ${i + 1} failed:`, error);
      }
    }
    
    return false;
  }

  /**
   * Sleep utility
   */
  private static sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

